"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_ID_HEADER_KEY = void 0;
exports.default = getAppHeaderLink;
const context_1 = require("@apollo/client/link/context");
const log_1 = require("@aurora/shared-utils/log");
const log = (0, log_1.getLog)(module);
exports.APP_ID_HEADER_KEY = 'kh-app-id';
/**
 * Link that adds application header to all request made.
 * @param appId application id
 */
function getAppHeaderLink(appId) {
    if (!appId) {
        log.error('app id not specified in request header. It is required.');
    }
    return (0, context_1.setContext)((_1, _a) => __awaiter(this, [_1, _a], void 0, function* (_, { headers }) {
        return {
            headers: Object.assign({ 
                /**
                 * LIA-79541 We put the kh-app-id header first to allow callers the ability to override on
                 * a per-call basis. This should probably not be allowed, but is currently required to
                 * satisfy the use case where we want to fetch the admin theme from the enduser app
                 * and currently the admin theme query requires the kh-app-id header to be set to "admin" in
                 * order for it to load.
                 *
                 * We can revert the order back once we either: 1) move Theme Editor and Page Builder
                 * into the admin-app at which point we will be in the context of the admin app when requesting the
                 * admin theme, or 2) if we allow the admin theme to be queried without requiring the
                 * kh-app-id header to be set to "admin".
                 */
                [exports.APP_ID_HEADER_KEY]: appId }, headers)
        };
    }));
}
//# sourceMappingURL=appHeaderLink.js.map